export interface PhoneCountry {
  iso: string;
  name: string;
  dialCode: string;
  flag: string;
  mask: string;
  maxDigits: number;
}

const GENERIC_MASK = '### ### ### ###';

export const PHONE_COUNTRIES: PhoneCountry[] = [
  { iso: 'BR', name: 'Brazil',          dialCode: '55',  flag: '🇧🇷', mask: '(##) #####-####',  maxDigits: 11 },
  { iso: 'US', name: 'United States',   dialCode: '1',   flag: '🇺🇸', mask: '(###) ###-####',   maxDigits: 10 },
  { iso: 'CA', name: 'Canada',          dialCode: '1',   flag: '🇨🇦', mask: '(###) ###-####',   maxDigits: 10 },
  { iso: 'MX', name: 'Mexico',          dialCode: '52',  flag: '🇲🇽', mask: '## #### ####',     maxDigits: 10 },
  { iso: 'AR', name: 'Argentina',       dialCode: '54',  flag: '🇦🇷', mask: '## ####-####',     maxDigits: 10 },
  { iso: 'CL', name: 'Chile',           dialCode: '56',  flag: '🇨🇱', mask: '# #### ####',      maxDigits: 9 },
  { iso: 'CO', name: 'Colombia',        dialCode: '57',  flag: '🇨🇴', mask: '### ### ####',     maxDigits: 10 },
  { iso: 'PE', name: 'Peru',            dialCode: '51',  flag: '🇵🇪', mask: '### ### ###',      maxDigits: 9 },
  { iso: 'UY', name: 'Uruguay',         dialCode: '598', flag: '🇺🇾', mask: '#### ####',        maxDigits: 8 },
  { iso: 'GB', name: 'United Kingdom',  dialCode: '44',  flag: '🇬🇧', mask: '#### ### ####',    maxDigits: 11 },
  { iso: 'IE', name: 'Ireland',         dialCode: '353', flag: '🇮🇪', mask: '## ### ####',      maxDigits: 9 },
  { iso: 'PT', name: 'Portugal',        dialCode: '351', flag: '🇵🇹', mask: '### ### ###',      maxDigits: 9 },
  { iso: 'ES', name: 'Spain',           dialCode: '34',  flag: '🇪🇸', mask: '### ### ###',      maxDigits: 9 },
  { iso: 'FR', name: 'France',          dialCode: '33',  flag: '🇫🇷', mask: '# ## ## ## ##',    maxDigits: 9 },
  { iso: 'DE', name: 'Germany',         dialCode: '49',  flag: '🇩🇪', mask: '### ########',     maxDigits: 11 },
  { iso: 'IT', name: 'Italy',           dialCode: '39',  flag: '🇮🇹', mask: '### ### ####',     maxDigits: 10 },
  { iso: 'NL', name: 'Netherlands',     dialCode: '31',  flag: '🇳🇱', mask: '## ### ####',      maxDigits: 9 },
  { iso: 'BE', name: 'Belgium',         dialCode: '32',  flag: '🇧🇪', mask: '### ## ## ##',     maxDigits: 9 },
  { iso: 'CH', name: 'Switzerland',     dialCode: '41',  flag: '🇨🇭', mask: '## ### ## ##',     maxDigits: 9 },
  { iso: 'AT', name: 'Austria',         dialCode: '43',  flag: '🇦🇹', mask: '### #######',      maxDigits: 10 },
  { iso: 'SE', name: 'Sweden',          dialCode: '46',  flag: '🇸🇪', mask: '## ### ## ##',     maxDigits: 9 },
  { iso: 'NO', name: 'Norway',          dialCode: '47',  flag: '🇳🇴', mask: '### ## ###',       maxDigits: 8 },
  { iso: 'DK', name: 'Denmark',         dialCode: '45',  flag: '🇩🇰', mask: '## ## ## ##',      maxDigits: 8 },
  { iso: 'FI', name: 'Finland',         dialCode: '358', flag: '🇫🇮', mask: '## ### ####',      maxDigits: 9 },
  { iso: 'PL', name: 'Poland',          dialCode: '48',  flag: '🇵🇱', mask: '### ### ###',      maxDigits: 9 },
  { iso: 'JP', name: 'Japan',           dialCode: '81',  flag: '🇯🇵', mask: '##-####-####',     maxDigits: 10 },
  { iso: 'KR', name: 'South Korea',     dialCode: '82',  flag: '🇰🇷', mask: '##-####-####',     maxDigits: 10 },
  { iso: 'CN', name: 'China',           dialCode: '86',  flag: '🇨🇳', mask: '### #### ####',    maxDigits: 11 },
  { iso: 'HK', name: 'Hong Kong',       dialCode: '852', flag: '🇭🇰', mask: '#### ####',        maxDigits: 8 },
  { iso: 'SG', name: 'Singapore',       dialCode: '65',  flag: '🇸🇬', mask: '#### ####',        maxDigits: 8 },
  { iso: 'IN', name: 'India',           dialCode: '91',  flag: '🇮🇳', mask: '##### #####',      maxDigits: 10 },
  { iso: 'AU', name: 'Australia',       dialCode: '61',  flag: '🇦🇺', mask: '### ### ###',      maxDigits: 9 },
  { iso: 'NZ', name: 'New Zealand',     dialCode: '64',  flag: '🇳🇿', mask: '### ### ####',     maxDigits: 10 },
  { iso: 'ZA', name: 'South Africa',    dialCode: '27',  flag: '🇿🇦', mask: '## ### ####',      maxDigits: 9 },
  { iso: 'AE', name: 'United Arab Emirates', dialCode: '971', flag: '🇦🇪', mask: '## ### ####', maxDigits: 9 },
  { iso: 'IL', name: 'Israel',          dialCode: '972', flag: '🇮🇱', mask: '##-###-####',      maxDigits: 9 },
];

export const DEFAULT_PHONE_COUNTRY_ISO = 'BR';

export function findPhoneCountryByIso(iso: string): PhoneCountry | undefined {
  return PHONE_COUNTRIES.find((c) => c.iso === iso);
}

export function findPhoneCountryByDialCode(dialCode: string): PhoneCountry | undefined {
  return PHONE_COUNTRIES.find((c) => c.dialCode === dialCode);
}

export function formatNationalNumber(digits: string, mask: string): string {
  if (!digits) return '';
  const effectiveMask = mask || GENERIC_MASK;
  let out = '';
  let pending = '';
  let di = 0;
  for (const ch of effectiveMask) {
    if (ch === '#') {
      if (di >= digits.length) break;
      out += pending + digits[di];
      pending = '';
      di += 1;
    } else {
      pending += ch;
    }
  }
  if (di < digits.length) out += digits.slice(di);
  return out;
}

export function buildPhoneExample(country: PhoneCountry): string {
  const sample = '12345678901234'.slice(0, country.maxDigits);
  return formatNationalNumber(sample, country.mask);
}
